import { render, staticRenderFns } from "./LegalList.vue?vue&type=template&id=08837a93&"
import script from "./LegalList.vue?vue&type=script&lang=js&"
export * from "./LegalList.vue?vue&type=script&lang=js&"
import style0 from "./LegalList.vue?vue&type=style&index=0&id=08837a93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports